import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Grid from "@material-ui/core/Grid";
// import CloseIcon from '../icons/CloseIcon';
// import BankIcon from '../icons/BankIcon';
// import InsuranceCompaniesIcon from '../icons/InsuranceCompaniesIcon';
// import InvestorsIcon from '../icons/InvestorsIcon';
// import CorporationsIcon from '../icons/CorporationsIcon';
// import Typography from '@material-ui/core/Typography';
import clsx from "clsx";
// import CloseIcon from '../icons/CloseIcon';
// import BankIcon from '../icons/BankIcon';
// import InsuranceCompaniesIcon from '../icons/InsuranceCompaniesIcon';
// import InvestorsIcon from '../icons/InvestorsIcon';
// import CorporationsIcon from '../icons/CorporationsIcon';
// import Typography from '@material-ui/core/Typography';
//let moment = require('moment');
//require("moment/min/locales.min");



export default function ChipsArray(props) {
	const classes = useStyles();
	const {key1, key2,key3} = props
	/*const [chipData, setChipData] = useState([
		{ key: 0, label: props.key1 },
		{ key: 1, label: props.key2 },
		{ key: 2, label: props.key3 },
	]);*/
	//moment.locale(`ru`);
	const chipData = [
		{ key: 0, label: key1 },
		{ key: 1, label: key2 },
		{ key: 2, label: key3 },
	]
	// moment.locale(`${props.LANG.toLowerCase()}`);
	return (
		<Grid
			item
			lg={12} md={12} sm={12}
			component="ul"
			className={clsx(classes.root, {
				[classes.topTagArray]: props.position === 'top',
				[classes.middleTagArray]: props.position === 'middle',
				[classes.bottomTagArray]: props.position === 'bottom',
			})}
		>
			{chipData.map((data) => {
				if (data.label !== null) {
					return (
						<li key={data.key} className={classes.li}>
							<Chip
								label={data.label}
								classes={{ root: classes.chip, clickable: classes.clickable, deletable: classes.deletable }}
								// onClick={props.handleClick ? () => props.handleClick(data.label) : ''}
								style={{ color: props.position === 'middle' ? '#FFF' : '', marginTop: props.position === 'middle' ? 7 : 0 }}
							/>
						</li>
					);
				}
			})}
		</Grid>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		// justifyContent: 'center',
		flexWrap: 'wrap',
		listStyle: 'none',
		color: '#F00',
		justifyContent: 'start',
		padding: '0 12px'
	},

	chip: {
		height: 24,
		margin: 0,
		padding: theme.spacing(0, 1),
		backgroundColor: '#BCBBD0',
		fontSize: 13,
		lineHeight: '16px',
		color: '#FFF',
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,

		'& > span': {
			padding: 0
		},
	},

	clickable: {
		height: 24,
		margin: 0,
		padding: theme.spacing(0, 1),
		backgroundColor: '#BCBBD0',
		fontSize: 13,
		lineHeight: '16px',
		color: '#FFF',
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,

		'& > span': {
			padding: 0
		},

		'&:hover': {
			background: '#BCBBD0',
		},

		'&:focus': {
			background: '#BCBBD0',
		}
	},

	deletable: {
		height: 24,
		margin: 0,
		padding: theme.spacing(0, 1),
		backgroundColor: '#BCBBD0',
		fontSize: 13,
		lineHeight: '16px',
		color: '#FFF',
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,

		'& > span': {
			padding: 0
		},

		'&:hover': {
			background: '#BCBBD0',
		},

		'&:focus': {
			background: '#BCBBD0',
		}
	},

	li: {
		margin: '0 3.5px',

		'&:first-child': {
			marginLeft: 0
		},

		'&:last-child': {
			marginRight: 0
		},
	},

	topTagArray: {
		padding: '0 0 8px 0 !important',
		justifyContent: 'flex-end',
	},

	middleTagArray: {
		padding: '0 12px !important',
		marginTop: "-7px",

		"& > li": {
			margin: '0 7px 0 0',
	
			// '&:first-child': {
			// 	margin: 0
			// },
	
			'&:last-child': {
				margin: 0
			},
		},
	},

	bottomTagArray: {
		padding: '0 12px !important',
	}
}));